
import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import Tooltip from './tooltip.vue';

@Component({
  components: { Tooltip },
  provide: function () {
    return { child: this };
  },
})
export default class TooltipAble extends Vue {
  @Prop()
  protected readonly tooltipLabel!: string;
  @Prop()
  protected readonly tooltipText!: string;
}
